import { generateClient } from '@aws-amplify/api';
import type { GraphqlSubscriptionResult } from '@aws-amplify/api-graphql';
import type { OnEventPublished } from '../types/notifications';

export const getSubscription = (authToken: string) => {
    return generateClient().graphql({
        query: `
            subscription OnEventPublished {
                onEventPublished {
                    app
                    resource
                    resourceId
                    tenantId
                    userId
                    time
                    action
                    keys
                    data
                }
            }
        `,
        authToken
    }) as GraphqlSubscriptionResult<OnEventPublished>;
};
